module.exports = __webpack_public_path__ + "img/E-Wallet-amico.fcbe0efe.svg";